// extracted by mini-css-extract-plugin
module.exports = {"mhTextC":"mhTextC_mhTextC__tyQ1_"};